import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { companyApi } from '../../api/company.api';
import { useAuth } from '../../store/AuthContext';
import { useUI } from '../../store/UIContext';
import { PageHeader, Btn } from '../../components/ui/index';
import LeafletMapPicker from '../../components/map/LeafletMapPicker';

export default function AddPlacePage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { addToast } = useUI();
  const [companies, setCompanies] = useState([]);
  const [form, setForm] = useState({ company_id:'', name:'', lat:'', lng:'', address:'' });
  // dispatcher-only: mark this point as the fixed main-office location
  // instead of a company branch (see set_main_office/querySetMainOfficeLocation).
  const [isMainOffice, setIsMainOffice] = useState(false);
  const [loading, setLoading] = useState(false);
  const inp = { width:'100%', padding:'10px 14px', border:'1.5px solid #e2e8f0', borderRadius:8, fontSize:13, outline:'none', fontFamily:'inherit', boxSizing:'border-box' };

  useEffect(() => {
    companyApi.getCompanyList().then(r=>setCompanies(Array.isArray(r.data)?r.data:[])).catch(()=>{});
    if (user?.type === 'dispatcher') {
      companyApi.getMainOffice().then(r => {
        if (r.data) setForm(p => ({ ...p, lat: String(r.data.lat), lng: String(r.data.long), name: r.data.name || '', address: r.data.description || '' }));
      }).catch(() => {});
    }
  }, [user?.type]);

  const set = k => e => setForm(p=>({...p,[k]:e.target.value}));

  const submit = async () => {
    setLoading(true);
    try {
      if (isMainOffice) {
        await companyApi.setMainOffice({ lat: form.lat, long: form.lng, name: form.name || 'دفتر مرکزی', description: form.address });
        addToast('دفتر مرکزی ثبت شد', 'success');
      } else {
        // addPlace (views.py) reads company_name/lat/long/name/description -
        // this form's own field names (company_id/lng/address) don't match
        // any of those, so they were arriving as None server-side. company_id
        // also has to be resolved to the company's actual name since that's
        // what the backend looks up companies by, not its id.
        const company = companies.find(c => String(c.id) === String(form.company_id));
        await companyApi.addPlace({
          company_name: company?.name,
          name: form.name,
          lat: form.lat,
          long: form.lng,
          description: form.address,
        });
        addToast('مکان افزوده شد', 'success');
      }
      navigate('/map');
    } catch { addToast('خطا در افزودن مکان', 'error'); }
    setLoading(false);
  };

  return (
    <div className="fade-in">
      <PageHeader title={isMainOffice ? 'تعیین دفتر مرکزی' : 'افزودن مکان جدید'}/>
      <div style={{maxWidth:520,background:'#fff',borderRadius:16,border:'1px solid rgba(35,58,122,0.1)',padding:32,boxShadow:'0 4px 16px rgba(35,58,122,0.08)'}}>
        <div style={{display:'flex',flexDirection:'column',gap:14}}>
          {user?.type === 'dispatcher' && (
            <label style={{display:'flex',alignItems:'center',gap:8,fontSize:13,fontWeight:600,color:'#334155',cursor:'pointer',background:'#f8faff',padding:'10px 14px',borderRadius:8,border:'1px solid #e2e8f0'}}>
              <input type="checkbox" checked={isMainOffice} onChange={e=>setIsMainOffice(e.target.checked)} />
              این مکان دفتر مرکزی است
            </label>
          )}
          {!isMainOffice && (
            <div><label style={{fontSize:12,fontWeight:600,color:'#334155',display:'block',marginBottom:5}}>شرکت</label>
              <select value={form.company_id} onChange={set('company_id')} style={{...inp,cursor:'pointer'}}>
                <option value="">-- انتخاب شرکت --</option>
                {companies.map(c=><option key={c.id} value={c.id}>{c.display_name || c.name}</option>)}
              </select>
            </div>
          )}
          <div><label style={{fontSize:12,fontWeight:600,color:'#334155',display:'block',marginBottom:5}}>نام مکان</label><input value={form.name} onChange={set('name')} placeholder={isMainOffice ? 'دفتر مرکزی' : ''} style={inp}/></div>
          <div>
            <label style={{fontSize:12,fontWeight:600,color:'#334155',display:'block',marginBottom:5}}>موقعیت روی نقشه</label>
            <LeafletMapPicker
              lat={form.lat}
              lng={form.lng}
              onChange={(lat, lng) => setForm(p => ({ ...p, lat: String(lat), lng: String(lng) }))}
            />
          </div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
            <div><label style={{fontSize:12,fontWeight:600,color:'#334155',display:'block',marginBottom:5}}>عرض جغرافیایی</label><input value={form.lat} onChange={set('lat')} dir="ltr" style={inp}/></div>
            <div><label style={{fontSize:12,fontWeight:600,color:'#334155',display:'block',marginBottom:5}}>طول جغرافیایی</label><input value={form.lng} onChange={set('lng')} dir="ltr" style={inp}/></div>
          </div>
          <div><label style={{fontSize:12,fontWeight:600,color:'#334155',display:'block',marginBottom:5}}>آدرس</label><textarea value={form.address} onChange={set('address')} rows={2} style={{...inp,resize:'vertical'}}/></div>
          <div style={{display:'flex',gap:10,marginTop:8}}>
            <Btn variant="ghost" onClick={()=>navigate('/map')}>انصراف</Btn>
            <Btn onClick={submit} loading={loading}>ذخیره مکان</Btn>
          </div>
        </div>
      </div>
    </div>
  );
}